module.exports = __webpack_public_path__ + "static/media/HospedeCosta6.14234228.jpeg";